import Vue from 'vue'
import App from './App.vue'
import VModal from 'vue-js-modal';
import router from './router.js'
import VueToast from 'vue-toast-notification';
import VueAnalytics from 'vue-analytics';

Vue.config.productionTip = false;

import './style/scss/global.scss';
import 'leaflet/dist/leaflet.css';
import '@sintef/prune-cluster/dist/LeafletStyleSheet.css';
import 'leaflet.fullscreen/Control.FullScreen.css';
import 'vue-toast-notification/dist/theme-sugar.css';
import 'leaflet-basemaps/L.Control.Basemaps.css';
import 'intro.js/introjs.css';
import i18n from './i18n';
import 'vue-slider-component/theme/default.css';
import 'bootstrap';
import 'leaflet-draw/dist/leaflet.draw-src.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

Vue.use(VModal);
Vue.use(VueToast, { position: 'bottom'});

Vue.use(VueAnalytics, {
    id: Vue.prototype.$config['ga_pid'],
    router,
    debug: {
        // only send data to ga in production environment
        sendHitTask: process.env.NODE_ENV === 'production'
    },
    autoTracking: {
        // disable send req on same page change (e.g leaflet hash change)
        skipSamePath: true
    }
});

// make icon system available globally
import IconBase from "@/components/IconBase";
Vue.component('icon', IconBase);
// add all icons
const req = require.context('@/assets/img/icons/', false, /\.vue$/);
req.keys().map(key => {
    const name = key.match(/\w+/)[0]; // remove extension
    return Vue.component(name, req(key).default) // register component
});
new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
